import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type SourceType from 'webapp/models-custom/source-type';

interface Args {
	sourceType: SourceType;
}

export default class MetricLibraryGridBlockDatasetComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('connect') declare connectService: Service.Connect;
	@service('billing') declare billingService: Service.Billing;

	get dataSourceType() {
		return this.args.sourceType;
	}

	get alertInfo() {
		const learnMoreIcon: IconName = 'Book';
		return {
			title: `The ${this.dataSourceType.name} integration is transitioning to datasets`,
			description: `<strong>We recommend creating a dataset first, then building metrics from it.</strong>
			Datasets enable advanced filtering, data merging, calculated columns, type casts,
			raw-level drill-down, and better performance. Direct metric creation on the data
			source (legacy) will be deprecated.`,
			buttonText: 'New dataset',
			buttonAction: this.migrateToDatasets,
			learnMoreIcon,
			learnMoreText: 'Learn more',
			learnMoreLink: this.dataSourceType.legacyCustomSourceTypeSourceMigrationLink,
		};
	}

	@action
	migrateToDatasets() {
		// TODO: Implement migration to datasets when tool is ready
	}
	<template>
		<div class="ml-section ml-section--deprecation">
			<div class="card">
				<div class="left">
					<CommonUiIconComponent @name="Alert" @size="lg" @class="alert" />
				</div>
				<div class="center">
					<h3>
						{{this.alertInfo.title}}
					</h3>
					<p>
						{{{this.alertInfo.description}}}
					</p>
				</div>
				<div class="right">
					{{!-- <a role="button" class="button" {{on "click" this.alertInfo.buttonAction}}>
                {{this.alertInfo.buttonText}}
            </a> --}}
					{{#unless this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins}}
						<a class="link" href={{this.alertInfo.learnMoreLink}} target="_blank">
							<CommonUiIconComponent
								@name={{this.alertInfo.learnMoreIcon}}
								@size="sm"
							/>
							{{this.alertInfo.learnMoreText}}
						</a>
					{{/unless}}
				</div>
			</div>
		</div>
	</template>
}
